// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"957":"54a5c463482d523e","4724":"b6323009d4472833","6325":"38b843a21de1195f"}[chunkId] + ".css";
};